(function () {
  if (window.__rotPv) return; window.__rotPv = true;
  var each = function (n) { return n >= 4 ? 27.5 : n === 3 ? 30 : n === 2 ? 35 : 45; };
  var $$ = function (v) { return '$' + (v % 1 ? v.toFixed(2) : v); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
  var WORD = ['', 'one', 'two', 'three', 'four'];
  var CHEV = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M10 3 5 8l5 5"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m6 3 5 5-5 5"/></svg>';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function data() { var el = document.querySelector('[data-rot-products]'); try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; } }
  function curN() { var t = document.querySelector('.rot-pdp .rot-tier[aria-pressed="true"]'); return t ? Number(t.getAttribute('data-n')) : 3; }
  function hasPicks() { try { var d = JSON.parse(sessionStorage.getItem('rotDraft') || 'null'); return !!(d && d.ids && d.ids.length > 1); } catch (e) { return false; } }
  var sheet = null, card = null, closeTimer = null;
  function close(after) {
    if (!sheet || sheet.hidden) { if (after) after(); return; }
    sheet.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { sheet.hidden = true; if (after) after(); else if (card) card.focus(); }, reduce ? 0 : 380);
  }
  function idx() { var g = sheet.querySelector('.g'); return g ? Math.round(g.scrollLeft / Math.max(1, g.clientWidth)) : 0; }
  function dots() {
    var g = sheet.querySelector('.g'), d = sheet.querySelector('.dots'); if (!g || !d) return;
    var count = g.children.length, i = idx();
    var gw = sheet.querySelector('.gw');
    if (count < 2) { d.innerHTML = ''; gw.removeAttribute('data-multi'); return; }
    gw.setAttribute('data-multi', '');
    var h = ''; for (var k = 0; k < count; k++) h += '<span class="' + (k === i ? 'on' : '') + '"></span>';
    d.innerHTML = h;
    var pv = sheet.querySelector('.nav.prev'), nx = sheet.querySelector('.nav.next');
    if (pv) pv.disabled = i <= 0;
    if (nx) nx.disabled = i >= count - 1;
  }
  function go(dir) { var g = sheet.querySelector('.g'); if (!g) return; g.scrollTo({ left: (idx() + dir) * g.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
  function open(p, cardEl) {
    card = cardEl;
    clearTimeout(closeTimer);
    if (!sheet) {
      sheet = document.createElement('div'); sheet.className = 'rot rot-pv'; sheet.hidden = true;
      sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true');
      document.body.appendChild(sheet);
      sheet.addEventListener('click', function (e) {
        var nv = e.target.closest('[data-pv-nav]'); if (nv) { if (!nv.disabled) go(Number(nv.getAttribute('data-pv-nav'))); return; }
        if (e.target.closest('[data-pv-close]')) { close(); return; }
        if (e.target.closest('[data-pv-add]')) { var c = card; card = null; close(function () { if (c) { var a = c.querySelector('.a'); (a || c).click(); } }); }
      });
      sheet.addEventListener('scroll', function (e) { if (e.target.classList && e.target.classList.contains('g')) dots(); }, true);
      document.addEventListener('keydown', function (e) {
        if (!sheet || sheet.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') go(-1);
        else if (e.key === 'ArrowRight') go(1);
      });
    }
    var n = curN();
    sheet.setAttribute('aria-label', p.t);
    sheet.innerHTML = '<button type="button" class="scrim" data-pv-close tabindex="-1" aria-label="Close"></button><div class="panel"><span class="grab" aria-hidden="true"></span><button type="button" class="x" data-pv-close aria-label="Close">×</button>' +
      '<div class="gw"><button type="button" class="nav prev" data-pv-nav="-1" aria-label="Previous photo">' + CHEV + '</button><div class="g"><img src="' + esc(p.i) + '" alt="' + esc(p.t) + '"></div><button type="button" class="nav next" data-pv-nav="1" aria-label="Next photo">' + CHEV_R + '</button></div><div class="dots"></div>' +
      '<div class="info"><p class="n">' + esc(p.t) + '</p><p class="c">' + esc(p.c !== p.t ? p.c : '') + '</p>' +
      '<p class="pr"><s>$45</s><b>' + $$(each(n)) + '</b> in your ' + WORD[n] + ', plus free shipping</p>' +
      '<button type="button" class="rot-btn" data-pv-add>Add to my ' + WORD[n] + '</button>' +
      (p.h ? '<a class="pv-link" href="/products/' + encodeURIComponent(p.h) + '">View full product page</a><p class="pv-note">' + (hasPicks() ? 'Your picks stay saved. Pick up right where you left off.' : 'Your Rotation picks carry over to every hat page.') + '</p>' : '') + '</div></div>';
    sheet.classList.remove('is-open');
    sheet.hidden = false;
    void sheet.offsetHeight;
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var x = sheet.querySelector('.x'); if (x) x.focus({ preventScroll: true });
    if (p.h) {
      fetch('/products/' + encodeURIComponent(p.h) + '.js').then(function (r) { return r.json(); }).then(function (d) {
        var imgs = (d.images || []).slice(0, 6);
        if (imgs.length < 2 || sheet.hidden) return;
        sheet.querySelector('.g').innerHTML = imgs.map(function (u) { u = u.indexOf('//') === 0 ? 'https:' + u : u; return '<img src="' + esc(u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=900') + '" alt="" loading="lazy">'; }).join('');
        dots();
      }).catch(function () {});
    }
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('.rot-pdp .rot-opt'); if (!c || e.target.closest('.rot-opt .a')) return;
    e.preventDefault(); e.stopPropagation();
    var id = Number(c.getAttribute('data-pick'));
    var p = data().find(function (x) { return x.id === id; });
    if (p) open(p, c);
  }, true);
  function syncCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('cart-count').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    }).catch(function () {});
  }
  document.addEventListener('cart:refresh', function () { setTimeout(syncCount, 800); });
  document.addEventListener('cart:updated', function () { setTimeout(syncCount, 300); });
})();